<template>
  <a-tabs type="card" class="mb-2">
    <a-tab-pane key="1">
      <template #tab>
        <div class="d-flex align-items-center h-full">
          <Skeleton width="80px" />
        </div>
      </template>
      <div class="d-flex flex-column" style="gap: 10px;">
        <div
          v-for="key in 2"
          :key="key"
          class="d-flex"
        >
          <a-collapse accordion class="w-full">
            <a-collapse-panel :key="key">
              <template #header>
                <Skeleton width="120px" />
              </template>
              <div class="d-flex flex-column" style="gap: 10px;">
                <Skeleton width="100%" />
                <Skeleton width="240px" />
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'

export default {
  components: {
    Skeleton,
  },
}
</script>
